module.exports = __webpack_public_path__ + "img/my-image (2).9827019f.png";